import React from 'react';
import { LandingPagesList } from '@/components/features/CampaignStructure';
import type { Campaign } from '@/types/campaign';
import type { LandingPageData } from '../hooks/useCampaignData';

interface CampaignLandingPagesProps {
  campaign: Campaign;
  landingPageData: LandingPageData;
  selectedLandingPages: Map<string, boolean>;
  selectedAdGroups: Set<string>;
  onLandingPageToggle: (url: string, authorized: boolean) => void;
}

/**
 * Landing pages section with toggle permissions.
 */
export function CampaignLandingPages({
  campaign,
  landingPageData,
  selectedLandingPages,
  selectedAdGroups,
  onLandingPageToggle,
}: CampaignLandingPagesProps) {
  if (!landingPageData.urlDetails.length) {
    return null;
  }

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow border">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">
        Landing Pages ({landingPageData.urlDetails.length})
      </h2>
      <p className="text-sm text-gray-600 mb-4">
        Grant Flouri access to scan your landing pages for personalized AI recommendations:
      </p>
      <LandingPagesList
        landingPages={landingPageData.urlDetails}
        onLandingPageToggle={onLandingPageToggle}
        selectedLandingPages={selectedLandingPages}
        campaign={campaign}
        selectedAdGroups={selectedAdGroups}
      />
    </div>
  );
}
